import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';

const tagName = 'div';

register('wm-progress-bar', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          return `<${tagName} wmProgressBar ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
